import { zodResolver } from '@hookform/resolvers/zod';
import { X } from 'lucide-react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

import { useUpdateCategory } from '@/api/category/use-update-category.ts';
import type { CategoryDto, UpdateCategoryDto } from '@/api/types';
import FormInput from '@/components/form/form-input/form-input.tsx';
import { Button } from '@/components/ui/button.tsx';

const updateCategorySchema = z.object({
  name: z
    .string()
    .min(1, 'Category name is required')
    .max(50, 'Category name must be less than 50 characters'),
});

type CategoryBoxEditProps = {
  projectId: string;
  category: CategoryDto;
  onClose: () => void;
};

const CategoryBoxEdit = ({ projectId, category, onClose }: CategoryBoxEditProps) => {
  const form = useForm<UpdateCategoryDto>({
    resolver: zodResolver(updateCategorySchema),
    defaultValues: { name: category.name },
  });

  const { mutateAsync: updateCategory, isPending } = useUpdateCategory(projectId!);

  const onSubmit = (data: UpdateCategoryDto) => {
    updateCategory({ uuid: category.uuid, data })
      .then(() => onClose())
      .catch(() => undefined);
  };

  return (
    <FormProvider {...form}>
      <div className="flex items-center gap-2 flex-1">
        <FormInput name="name" label="Name" labelHidden />
        <Button type="submit" size="sm" disabled={isPending} onClick={form.handleSubmit(onSubmit)}>
          Save
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={onClose}>
          <X className="size-3.5" />
        </Button>
      </div>
    </FormProvider>
  );
};

export default CategoryBoxEdit;
